type Listener<T> = (payload: T) => void;

export const createEvent = <T = void>() => {
    const listeners = new Set<Listener<T>>();

    return {
        emit(payload?: T) {
            listeners.forEach(listener => {
                listener(payload as T);
            });
        },
        // emit(...args: T extends void ? [] : [T]) {
        //     listeners.forEach(listener => {
        //         listener(args[0] as T);
        //     });
        // },

        on(listener: Listener<T>) {
            listeners.add(listener);

            return () => listeners.delete(listener);
        },

        clear() {
            listeners.clear();
        },
    };
};
